import {
  PERSONALIZATION_INVALID_CHARACTERS,
  DEFAULT_PERSONALIZATION_MAX_LENGTH
} from './student-personalization.constants';
import { getNameValidationError } from '@app/utils/name-validation';

export type PersonalizationValidationFailure = 'invalidCharacter' | 'invalidLength' | null;

export function normalizePersonalizationName(value: string | null | undefined): string {
  return value?.trim() ?? '';
}

export function hasPersonalizationValue(value: string | null | undefined): boolean {
  return normalizePersonalizationName(value).length > 0;
}

export function getPersonalizationNameValidationFailure(
  value: string | null | undefined,
  maxLength: number = DEFAULT_PERSONALIZATION_MAX_LENGTH
): PersonalizationValidationFailure {
  return getNameValidationError<'invalidCharacter' | 'invalidLength'>(
    value,
    maxLength,
    PERSONALIZATION_INVALID_CHARACTERS,
    { invalidChar: 'invalidCharacter', invalidLength: 'invalidLength' }
  );
}

export function isPersonalizationNameValid(
  value: string | null | undefined,
  maxLength: number = DEFAULT_PERSONALIZATION_MAX_LENGTH
): boolean {
  return getPersonalizationNameValidationFailure(value, maxLength) === null;
}

export function isPersonalizationSelectionValid(
  value: string | null | undefined,
  validationStatus: boolean,
  isSelected: boolean,
  allowEmptyValue: boolean
): boolean {
  if (!validationStatus) {
    return false;
  }

  if (allowEmptyValue || !isSelected) {
    return true;
  }

  return hasPersonalizationValue(value);
}

export function getPersonalizationNameError(
  value: string | null | undefined,
  maxLength: number = DEFAULT_PERSONALIZATION_MAX_LENGTH
): string | null {
  const validationFailure = getPersonalizationNameValidationFailure(value, maxLength);

  switch (validationFailure) {
    case 'invalidCharacter':
      return 'STUDENT_PREFERRED_FIRST_NAME_INVALID_CHAR_ERROR';
    case 'invalidLength':
      return 'STUDENT_PREFERRED_FIRST_NAME_INVALID_LENGTH_ERROR';
    default:
      return null;
  }
}
